import { render } from "./SquadDetail.vue?vue&type=template&id=6743008d"
import script from "./SquadDetail.vue?vue&type=script&lang=js"
export * from "./SquadDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__